import { URLS } from '../../../consts/endpoints';
import { getData, updateData } from '../../../utils/http';
import { isUndefined } from '../../../utils/isDefined';
import RESPONSE_CODES from '../../../consts/responseCodes';
import showSnackbar from '../../../utils/showSnackbar';

const updateUserInfo = async ({ clientId, userInfo }) => {
  const { accountUserId, phoneNumber, ...restInfo } = userInfo;
  try {
    const subResponse = await getData(
      `${URLS.QUOTE_CLIENTS}/${clientId}/subscriptions/search?phoneNumber[]=${phoneNumber}`
    );

    const subId = subResponse?.[phoneNumber]?.[0]?.id;

    if (isUndefined(subId)) {
      return { error: 'Subscription ID is not available' };
    }

    const response = await updateData({
      url: `${URLS.QUOTE_CLIENTS}/${clientId}/subscriptions/${subId}`,
      data: { user_info: { ...restInfo } }
    });

    if (response.status === RESPONSE_CODES.NO_CONTENT) {
      showSnackbar({
        intlTextKey: 'MESSAGE.UPDATE.USER_INFO',
        messageType: 'success'
      });
    }

    return { editComplete: true };
  } catch (error) {
    console.error('Error updating user info:', error);
    throw error;
  }
};

export default updateUserInfo;
